
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import { uiStore, documentStore } from "@/store/store";
import NumberInput from "@/components/Reusable/CustomInputs/NumberInput.vue";
import UnitInput from "@/components/Reusable/CustomInputs/UnitInput/UnitInput.vue";
import { UnitInputValue } from "@/types/unit";

@Component({
  components: { UnitInput, NumberInput, NiceButton, TextInput, Dropdown }
})
export default class PreviewSize extends Vue {
  get isGlobalBlock() {
    return documentStore.document.documentMeta.postType === "breakdance_block";
  }

  get canvasPreviewWidth() {
    return uiStore.canvasPreviewWidth;
  }

  get width() {
    return uiStore.canvasPreviewWidth.previewSize.width || undefined;
  }

  get height() {
    return uiStore.canvasPreviewWidth.previewSize.height || undefined;
  }

  changeWidth(width: UnitInputValue) {
    const newWidth = `${width?.number || 0}`;
    uiStore.changePreviewWidthMutation({
      ...this.canvasPreviewWidth,
      previewSize: {
        ...this.canvasPreviewWidth.previewSize,
        width: parseFloat(newWidth)
      }
    });
  }

  changeHeight(height: UnitInputValue) {
    const newHeight = `${height?.number || 0}`;

    uiStore.changePreviewWidthMutation({
      ...this.canvasPreviewWidth,
      previewSize: {
        ...this.canvasPreviewWidth.previewSize,
        height: parseFloat(newHeight)
      }
    });
  }
}
